<template>
    <button
        class="group flex gap-x-2 rounded-md p-1 text-sm text-z-primary-600 transition-all duration-100 ease-out hover:bg-z-primary-50"
        @click="copyEventTypePreviewToClipboard"
        @mouseover="iconsShown = true"
        @mouseleave="iconsShown = false"
    >
        <div v-if="iconsShown">
            <Link
                class="text-z-primary-500"
                :size="20"
                :stroke-width="1.75"
                absolute-stroke-width
            />
        </div>
    </button>
</template>

<script setup lang="ts">
import route from "ziggy-js";
import { useClipboard } from "@vueuse/core";
import { Link, ClipboardCheck } from "lucide-vue-next";
import { ref } from "vue";

const { copy, copied } = useClipboard();

const iconsShown = ref(false);

const props = defineProps<{
    eventType: any;
}>();

function copyEventTypePreviewToClipboard() {
    copy(
        route("public.event-types.show", {
            eventTypeUuid: props.eventType.uuid,
        }),
    );
}
</script>

<style scoped></style>
